import { useState } from "react";
import { useRouteError, useNavigate } from "react-router-dom";
import { captureException } from "@sentry/react";
import { Turtle, RefreshCw, Home, Copy } from "lucide-react";

import { Alert, AlertDescription, AlertTitle } from "src/@/components/ui/alert";
import { Button } from "src/@/components/ui/button";
import { toast } from "sonner";

import { Routes } from "src/modules/navigation/routes";
import { copyToClipboard } from "src/modules/utils/helpers";

export const ErrorBoundary = () => {
    const error = useRouteError();
    const navigate = useNavigate();
    const [sentryId, setStentryId] = useState<string>();

    if (error && !sentryId) {
        console.log(error);
        setStentryId(captureException(error));
    }

    const handleRefresh = () => window.location.reload();
    const handleGoToDashboard = () => navigate(Routes.Index);
    const handleCopyErrorId = () => {
        if (sentryId) {
            copyToClipboard(sentryId);
            toast.success("Error ID copied to clipboard");
        }
    };

    return (
        <div>
            <Alert className="mx-auto mt-8 w-fit">
                <Turtle className="h-4 w-4" />
                <AlertTitle>Something went wrong</AlertTitle>
                <AlertDescription className="mt-2">
                    Please contact support if the issue persists.
                    {sentryId && (
                        <>
                            <br />
                            Error ID: <code>{sentryId}</code>
                        </>
                    )}
                </AlertDescription>
                <div className="mt-4 flex gap-2">
                    {sentryId && (
                        <Button 
                            onClick={handleCopyErrorId}
                            variant="outline"
                            size="sm"
                            className="flex items-center gap-2"
                        >
                            <Copy className="h-4 w-4" />
                            Copy Error ID
                        </Button>
                    )}
                    <Button 
                        onClick={handleRefresh}
                        variant="outline"
                        size="sm"
                        className="flex items-center gap-2"
                    >
                        <RefreshCw className="h-4 w-4" />
                        Reload Page
                    </Button>
                    <Button 
                        onClick={handleGoToDashboard}
                        variant="outline"
                        size="sm"
                        className="flex items-center gap-2"
                    >
                        <Home className="h-4 w-4" />
                        Go to Dashboard
                    </Button>
                </div>
            </Alert>
        </div>
    );
};
